<template>
<div id="app">
    <a-config-provider :locale="locale" :autoInsertSpaceInButton="false">
        <router-view />
    </a-config-provider>

    <EditPhone ref="edit-phone" :show-btn='false'/>

    <ShowInsurance ref="insurance-notice" :show-btn='false' :scene="36"/>

    <ShowServiceChargeTip ref="service-charge-tip" :show-btn='false'/>
</div>
</template>
<script>
import dayjs from 'dayjs'
import Core from './core'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
const LOGIN_TYPE = Core.Const.LOGIN_TYPE
const OPERATOR_MODE = Core.Const.OPERATOR.MODE

export default {
    components: {
        EditPhone: () => import('./components/popup-btn/EditPhone.vue'),
        ShowInsurance: () => import('./components/popup-btn/ShowInsurance.vue'),
        ShowServiceChargeTip: () => import('./components/popup-btn/ShowServiceChargeTip.vue'),
    },
    data() {
        return {
            locale: zhCN,

            token: '',
        };
    },
    created() {
        this.token = Core.Data.getToken()
        console.log('APP created'/* , this.token */)

        if (this.token) {
            this.getAuthority()
        }
    },
	mounted() {
        console.log('APP mounted'/* , this.token */)
        if (Core.Util.auth('OPERATOR')) {
            this.checkModelShow();
        }
    },
    watch: {
        $route: {
            deep: true,
            handler(currRouter, formRouter) {
                // console.log('APP watch $route')
                if (Core.Util.auth('OPERATOR') && currRouter.fullPath !== '/' && formRouter.fullPath !== '/') {
                    this.checkModelShow(currRouter, formRouter);
                }
            }
        }
    },
    methods: {
        // 更新权限
        getAuthority() {
            if (Core.Data.getLoginType() === LOGIN_TYPE.CLEARING_ACCOUNT) {
                Core.Data.setAuthority({ CLEARING_ACCOUNT: true })
                return
            }
            Core.Api.Authority.listByUser().then(res => {
                Core.Util.getAuthority(res)
            }).catch(err => {
                console.log('获取权限失败', err)
                // Core.Util.getAuthority({})
            })
        },

        // 检查弹框弹出
        async checkModelShow(currRouter = this.$route, formRouter) {
            console.log('APP checkModelShow 当前路由:', currRouter, '上一路由', formRouter)
            const noCheckPath = ['Login', 'Test1', 'Test2', 'CameraPlayer', 'Statistic', 'StatisticMap']

            if (currRouter.name && noCheckPath.includes(currRouter.name)) {
                return console.log('checkModelShow 处于屏蔽弹框弹出的页面上')
            }

            const checkList = [
                () => this.checkOperatorPhoneValid(),
                () => this.checkInsuranceNotice(currRouter, formRouter),
                () => this.checkServiceChargeNotice(currRouter, formRouter),
            ]

            for (const func of checkList) {
                try {
                    let res = await func();
                    console.log('checkModelShow res:', res)
                } catch (err) {
                    console.log('checkModelShow err:', err)
                }
            }
        },

        // 检查运营商联系方式是否合理
        checkOperatorPhoneValid() {
            console.log('checkModelShow:检查运营商联系方式是否有效')
            return new Promise(async (resolve) => {
                try {
                    const { operator } = await Core.Api.Operator.detail();
                    const phone = operator.phone;
                    if (Core.Util.regRuleTest(phone, 'phone')) {
                        resolve({ message: '运营商联系方式有效' }); return;
                    }
                    this.$warning({
                        title: '您的联系方式不合理',
                        content: '请您先修正您的联系方式',
                        okText: '确定',
                        cancelText: '取消',
                        closable: false,
                        keyboard: false,
                        onOk:() => {
                            this.$refs['edit-phone'].handleModalShow(resolve)
                        },
                    });
                } catch (err) {
                    resolve({ message: '获取运营商信息失败', err })
                }
            })
        },

        // 检查是否需要弹出场地险购买弹窗
        checkInsuranceNotice(currRouter, formRouter) {
            console.log('checkModelShow:检查是否需要弹出场地险购买弹窗')
            return new Promise((resolve) => {
                const lastShowDay = dayjs(Core.Data.getInsuranceTipTime()).format('YYYY-MM-DD')
                const today = dayjs().format('YYYY-MM-DD')

                if (formRouter && formRouter.name !== 'Login') {
                    // 有上一个路由 且 不是从登录页过来 => 非首次进入sass系统 或 重新登录后再进入 => 无需弹出
                    return resolve({ message: '场地险购买弹窗:无需弹出' })
                }

                // 没有上一路由 => 首次进入sass系统 => 判断今日是否是首次弹出
                // 从登录页进入 => 判断是否是正常登录后的进入(非正常:手动去到登录页再手动进入内页) => 在系统内部退出登录时会清空上次弹出时间 => 判断今日是否是首次弹出
                if (lastShowDay === today) {
                    return resolve({ message: '场地险购买弹窗:今日已弹出过' })
                }
                if (this.$refs['insurance-notice']) {
                    this.$refs['insurance-notice'].handleModalShow(resolve)
                } else {
                    this.$Bus.on('InsuranceNoticeMounted', () => {
                        console.log('$Bus.on:InsuranceNoticeMounted')
                        this.$refs['insurance-notice'].handleModalShow(resolve);
                        this.$Bus.off('InsuranceNoticeMounted')
                    })
                }

            })
        },

        // 检查是否需要弹出服务费公告
        checkServiceChargeNotice(currRouter, formRouter) {
            console.log('checkModelShow:检查是否需要弹出服务费公告')
            return new Promise((resolve, reject) => {
                if (!formRouter || formRouter.name !== 'Login') {
                    // 不是从登录页过来 => 无需弹出
                    return resolve({ message: '服务费公告:非登录后进入,无需弹出' })
                }
                if (Core.Data.getServiceChargeTipFlag()) {
                    return resolve({ message: '服务费公告:已弹出过,无需弹出' })
                }
                if (this.isSubOperator()) {
                    return resolve({ message: '服务费公告:非主运营商,无需弹出' })
                }
                const FORBID_OPERATOR = [
                    18692, /* 福建宁德惠智无限科技有限公司 */
                    11606, /* zxp-test */
                    18895, /* zxp-直营 */
                    17395, /* HW7530 可撤 */
                    16138, /* 17799869279 华消科技 */
                ]
                if (FORBID_OPERATOR.includes(Core.Data.getUser().id)) {
                    return resolve({ message: '服务费公告:独立屏蔽的运营商,无需弹出' })
                }

                this.$refs['service-charge-tip'].handleModalShow(resolve)
                if (this.$refs['service-charge-tip']) {
                    this.$refs['service-charge-tip'].handleModalShow(resolve)
                } else {
                    this.$Bus.on('ServiceChargeTipMounted', () => {
                        this.$refs['service-charge-tip'].handleModalShow(resolve);
                        this.$Bus.off('ServiceChargeTipMounted')
                    })
                }
            })
        },
        // 确认是否需要弹窗
        isSubOperator() {
            let flagSubOperator = false
            let user = Core.Data.getUser()
            if (user.type === LOGIN_TYPE.OPERATOR_MEMBER) {
                if (user.mode === OPERATOR_MODE.DIRECTSALES && user.parent_mode === OPERATOR_MODE.DIRECTSALES) {
                    // 直营的子级直营
                    flagSubOperator = true
                }
            }
            return flagSubOperator
        },
    }
};
</script>

<style lang="scss">

</style>
